import i18n from '@app/app/i18n/config';

/**
 * Получает текущий язык из i18n для использования в заголовке Accept-Language
 * @returns Код языка (например, 'en', 'es', 'pt-BR')
 */
export const getCurrentLanguage = (): string => {
  // Проверяем, что i18n инициализирован (может быть undefined на сервере)
  if (typeof window !== 'undefined' && i18n && i18n.language) {
    return i18n.language;
  }
  // Fallback на английский, если i18n еще не инициализирован
  return 'en';
};
